import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { DealSaveButtonMobile as n } from "../../DealSaveButton/DealSaveButtonMobile.js";
import { ShareDealButton as a } from "../../ShareDealButton/index.js";
import { Container as l } from "./style.js";
function s({
  hasSaveButton: e,
  isSaved: i,
  id: o,
  dispatch: r
}) {
  return /* @__PURE__ */ m(l, { children: [
    e && /* @__PURE__ */ t(
      n,
      {
        isSaved: i || void 0,
        dispatch: r,
        id: o
      }
    ),
    /* @__PURE__ */ t(a, { dispatch: r, id: o })
  ] });
}
export {
  s as DealActionBarBottomMobile
};
